import script from "./MultiBusinessSection.vue?vue&type=script&setup=true&lang=js"
export * from "./MultiBusinessSection.vue?vue&type=script&setup=true&lang=js"

import "./MultiBusinessSection.vue?vue&type=style&index=0&id=7ede303c&lang=css"

const __exports__ = script;

export default __exports__